import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const PayableInvoiceDetailsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "PayableInvoiceDetails" */
      '../../../components/Treasury/PayableInvoiceDetails/PayableInvoiceDetails'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  enabledKey: 'internal',
  releaseState: 'internal',
  description:
    'Shows details for a given payable invoice. Offers editing and payment management.',
  friendlyName: 'Payable invoices details',
};
